import { useDeviceSize } from 'fitify-ui'
import { deviceSize } from 'fitify-ui/src/hooks/useDeviceSize'
import {
  AppstoreBadgeDarkIcon,
  GooglePlayBadgeDarkIcon,
} from 'fitify-ui/src/Icon/custom'
import type { LinkTypes } from 'fitify-ui-landing/src/@types'
import { ELEMENT_IDS } from 'fitify-ui-landing/src/@types/constants'
import dynamic from 'next/dynamic'
import { useTranslation } from 'next-i18next'

import { commonData } from '@/data/common'

import {
  StyledBadgeWrapper,
  StyledNavigation,
  StyledNavigationContainer,
  StyledNavigationLogoLink,
} from './Navigation.Styled'
import NavigationMenu, { NavigationVariant } from './NavigationMenu'

const NavigationMobile = dynamic(() => import('./NavigationMobile'))

interface NavigationProps {
  items: LinkTypes.Navigation[]
  logo?: React.ReactNode
  options?: {
    mobileEnabled?: boolean
  }
}

const Navigation = ({ items, logo, options }: NavigationProps) => {
  const { t } = useTranslation()
  const { windowWidth } = useDeviceSize()
  const isPhoneBreakpoint =
    windowWidth <= deviceSize.tabletPortraitUpperBoundary

  const mobileEnabled = isPhoneBreakpoint && options?.mobileEnabled

  return (
    <StyledNavigation id={ELEMENT_IDS.navigation}>
      <StyledNavigationContainer>
        <StyledNavigationLogoLink
          href="/"
          aria-label={t('cl_aria_label_go_to_homepage')}
        >
          {logo}
        </StyledNavigationLogoLink>
        {mobileEnabled ? (
          <NavigationMobile items={items} />
        ) : (
          <NavigationMenu
            items={items}
            variant={NavigationVariant.NAVIGATION}
          />
        )}
        <StyledBadgeWrapper>
          <a href={commonData.store.appStore} rel="noreferrer">
            <AppstoreBadgeDarkIcon />
          </a>
          <a href={commonData.store.playStore} rel="noreferrer">
            <GooglePlayBadgeDarkIcon />
          </a>
        </StyledBadgeWrapper>
      </StyledNavigationContainer>
    </StyledNavigation>
  )
}

export default Navigation
